import { render, staticRenderFns } from "./customer-card.vue?vue&type=template&id=09ea592c&"
import script from "./customer-card.vue?vue&type=script&lang=js&"
export * from "./customer-card.vue?vue&type=script&lang=js&"
import style0 from "./customer-card.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports